import { SAVE_USER, REMOVE_USER,GET_USER_PROFILE } from "../../util/actionTypes.js";

export const saveUserCredentials = (data) => {
    return {
        type: SAVE_USER,
        payload: data
    };
};

export const removeUser = () => {
    return {
        type: REMOVE_USER,
        payload: {}
    };
}; 
export const getUserProfile = () => async (dispatch) => {
  return {
        type: GET_USER_PROFILE,
        payload: {}
    };
};
 